export default __webpack_public_path__ + "static/media/menu.18f72b35.svg";